import { ExternalLink } from 'lucide-react'
import { CsDateField } from '@/components/Cs/CsDateField'
import { CsField, CsSection } from '@/components/Cs/CsSection'
import { csFieldClass } from '@/components/Cs/csFormStyles'
import type { CsAccountDetail } from '@/services/csService'

type Props = {
  account: CsAccountDetail
  onSave: (payload: Record<string, unknown>) => Promise<void>
}

export function CsAccountAgenda({ account, onSave }: Props) {
  return (
    <CsSection title='Agenda do cliente'>
      <div className='grid gap-1 sm:grid-cols-1'>
        <CsDateField
          label='Próxima reunião'
          value={account.proximaReuniao}
          onChange={(value) => void onSave({ proximaReuniao: value })}
        />
        <CsDateField
          label='Última reunião'
          value={account.ultimaReuniao}
          onChange={(value) => void onSave({ ultimaReuniao: value })}
        />
        <CsDateField
          label='Próximo check-in'
          value={account.proximoCheckIn}
          onChange={(value) => void onSave({ proximoCheckIn: value })}
        />
      </div>

      <div className='mt-4 space-y-3 border-t border-[var(--glass-border)] pt-4'>
        <CsField label='Link da gravação'>
          <div className='flex gap-2'>
            <input
              className={csFieldClass}
              defaultValue={account.linkGravacao ?? ''}
              placeholder='https://…'
              onBlur={(e) => void onSave({ linkGravacao: e.target.value || null })}
            />
            {account.linkGravacao && (
              <a
                href={account.linkGravacao}
                target='_blank'
                rel='noreferrer'
                className='flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-[var(--glass-border)] text-[var(--text-muted)] hover:text-accent'
                aria-label='Abrir gravação'
              >
                <ExternalLink size={14} />
              </a>
            )}
          </div>
        </CsField>

        <CsField label='Link ATA / Ekyte'>
          <div className='flex gap-2'>
            <input
              className={csFieldClass}
              defaultValue={account.linkAtaEkyte ?? ''}
              placeholder='https://…'
              onBlur={(e) => void onSave({ linkAtaEkyte: e.target.value || null })}
            />
            {account.linkAtaEkyte && (
              <a
                href={account.linkAtaEkyte}
                target='_blank'
                rel='noreferrer'
                className='flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-[var(--glass-border)] text-[var(--text-muted)] hover:text-accent'
                aria-label='Abrir ATA'
              >
                <ExternalLink size={14} />
              </a>
            )}
          </div>
        </CsField>
      </div>
    </CsSection>
  )
}
